<template>
  <v-container class="px-0">
    <v-expansion-panels v-model="panels" accordion>
      <v-expansion-panel>
        <v-expansion-panel-content class="obrigacoes-especiais-map-content">
          <v-simple-table dense>
            <template v-slot:default>
              <tbody>
                <tr>
                  <th class="subtitle-1">Arquivo</th>
                  <th class="subtitle-1">Ações</th>
                </tr>
                <tr v-for="(value, key) in uploadedFiles" :key="key">
                  <td class="px-4" style="width: 55% !important">
                    <span class="d-inline-flex">{{ value.nome }}</span>
                  </td>
                  <td class="px-4" style="width: 5% !important">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="primary"
                          min-width="0"
                          class="px-1"
                          fab
                          icon
                          x-small
                          v-bind="attrs"
                          v-on="on"
                          @click="$emit('mapeamento:apagar-arquivo', { arquivo_id: value.arquivo_id })"
                        >
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </template>
                      <span>Clique aqui para excluir o arquivo {{ value.nome }}</span>
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-container>
</template>
  
<script>
  export default {
    props: {
      uploadedFiles: {
        type: Array,
        default: () => []
      }
    },

    emits: ['mapeamento:apagar-arquivo'],

    data: () => ({
      panels: 0,
      headers: [
        {
          text: 'Nome',
          value: 'nome'
        },
        {
          text: 'Ações',
          value: 'acoes'
        }
      ]
    })
  };
</script>
  
  <style>
  .obrigacoes-especiais-map-content .v-expansion-panel-content__wrap {
    padding: 0 !important;
  }
</style>